export default __webpack_public_path__ + "static/media/LoyaltyCross.f180526b.svg";